var exports = {
  "JC": "UserProfilePopout.module__role___bG9sRk",
  "s$": "UserProfilePopout.module__roleRemoveIcon___bG9sRk",
  "Bx": "UserProfilePopout.module__iconSmall___bG9sRk",
  "bc": "UserProfilePopout.module__profileCustomStatus___bG9sRk",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___bG9sRk",
  "ZB": "UserProfilePopout.module__profileDisplayName___bG9sRk",
  "yn": "UserProfilePopout.module__profileDataWarning___bG9sRk",
  "zF": "UserProfilePopout.module__profilePopoutCard___bG9sRk",
};

module.exports = exports;
